import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import { newDatasetUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { datasetSourceEntities } from '../constants';

const DuplicateDatasetAction = ({
  code,
  newDatasetCode,
  readErrors,
  readStatus,
}) => (
  <RibbonMenu
    name="duplicate"
    icon="clone"
    message="actions.duplicate"
    url={newDatasetUrl(datasetSourceEntities.DATASET, code, newDatasetCode, '#')}
    className="aridhia-duplicate-dataset-action"
    disabled={readStatus !== states.SUCCESS || firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  datasets: {
    datasets,
    newDatasetCode,
  },
}, { category, code }) => {
  const dataset = findResult(datasets, category, code) || readStates;

  return {
    newDatasetCode,
    readErrors: dataset.readErrors,
    readStatus: dataset.readStatus,
  };
};

export default connect(mapStateToProps)(DuplicateDatasetAction);
